<ng-container *ngIf="selectedItem; else shareholders">
  <app-company-indirect-shareholder-container (checkingKyc)="checkKyc($event)" (backTo)="backToLayer($event)"
    (selected)="select($event)" (deleting)="delete($event)" (updating)="update($event)" (adding)="add($event)"
    [company]="company" (exist)="onExist()" [selectedCorporates]="selectedCorporates">
  </app-company-indirect-shareholder-container>
</ng-container>

<ng-template #shareholders>
  <div class="relative">
    <mat-toolbar color="primary" class="sticky top-0 !z-[100]">
      <div class="flex justify-between w-full items-center">
        <div class="inline overflow-auto py-2">
          <ng-container *ngIf="company">
            <button #btnBack mat-button (click)="onExist()">
              <mat-icon>apartment</mat-icon>
              {{ company.name }}
            </button>
            <mat-icon class="align-middle text-white">keyboard_arrow_right</mat-icon>
          </ng-container>

          <ng-container *ngIf="selectedCorporates">
            <ng-container *ngFor="let sh of selectedCorporates; let i = index; let last = last">
              <button mat-button (click)="backToLayer(i)">
                <mat-icon>apartment</mat-icon>
                {{ sh.officer.name }}
              </button>
              <mat-icon class="align-middle text-white" *ngIf="!last">keyboard_arrow_right</mat-icon>
            </ng-container>
          </ng-container>
        </div>

        <ng-container *ngIf="selectedCorporates">
          <ng-container *ngFor="let sh of selectedCorporates; let i = index; let last = last">
            <app-total-capital [totalCapitalValue]="sh.allocatedCapitalTotal"
              [capitalName]="'Total Capital of ' + sh.officer.name + ':'" *ngIf="last"></app-total-capital>
          </ng-container>
        </ng-container>
      </div>
    </mat-toolbar>
    <mat-tab-group *ngIf="corporateShareholders?.length || individualShareholders?.length; else empty"
      animationDuration="0ms">
      <mat-tab *ngIf="corporateShareholders?.length">
        <ng-template matTabLabel>
          <mat-icon class="mr-2">business</mat-icon>
          <span>Corporate Shareholders</span>
        </ng-template>
        <ng-template matTabContent>
          <app-company-indirect-shareholder-table [company]="company" (checkingKyc)="checkKyc($event)"
            (deleting)="delete($event)" (updating)="update($event)" [type]="'OfficerIndirectCompanyType'"
            (selected)="select($event)" [shareholders]="corporateShareholders"></app-company-indirect-shareholder-table>
        </ng-template>
      </mat-tab>

      <mat-tab *ngIf="individualShareholders?.length">
        <ng-template matTabLabel>
          <mat-icon class="mr-2">supervised_user_circle</mat-icon>
          <span>Individual Shareholders</span>
        </ng-template>
        <ng-template matTabContent>
          <app-company-indirect-shareholder-table [company]="company" (checkingKyc)="checkKyc($event)"
            (deleting)="delete($event)" (updating)="update($event)" [type]="'OfficerIndirectPersonType'"
            (selected)="select($event)"
            [shareholders]="individualShareholders"></app-company-indirect-shareholder-table>
        </ng-template>
      </mat-tab>
    </mat-tab-group>

    <mat-card-footer class="!flex justify-end !m-0 p-2">
      <button (click)="add(lastCorporate)" *ngIf="lastCorporate?.canCreateShareholder"
        class="flex gap-3 items-center rounded-lg cursor-pointer border-0 bg-[#2A8BC4] text-white px-3 py-2 font-secondary font-semibold hover:bg-[#43a0d2]">
        <mat-icon class="text-white">add</mat-icon>
        Add new shareholder
      </button>
    </mat-card-footer>

    <ng-template #empty>
      <div class="p-4">
        <ng-container *ngIf="isLimitDeep; else normalEmpty">
          <app-callout appearance="primary" [message]="limitDeepMessage"></app-callout>
        </ng-container>

        <ng-template #normalEmpty>
          <app-callout *ngIf="shouldShowNoNeedToListShareholdersMessage; else noRecords" appearance="primary"
            [message]="noNeedToListShareholdersMessage">
          </app-callout>
          <ng-template #noRecords>
            <table-no-record></table-no-record>
          </ng-template>
        </ng-template>
      </div>
    </ng-template>
  </div>
</ng-template>
